import { Field, Int } from '@nestjs/graphql'
import { BaseUpdateDto } from '../base/baseUpdate.dto'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class UpdateNotificationDto extends BaseUpdateDto<UpdateNotificationDto> {
  @Field({ nullable: true })
  active?: boolean

  @Field(t => Int, { nullable: true })
  typeFlags?: number

  @Field({ nullable: true })
  code?: string

  @Field({ nullable: true })
  permissionPreferenceKey?: string

  @Field({ nullable: true })
  templateId?: string

  @Field(t => Date, { nullable: true })
  lastQueuedDate?: Date
}
